import { Component, OnInit } from '@angular/core';
import { AuthenticationService, ListsService } from '../_services';
import { User } from '../_models';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment.prod';

declare const $ : any;

@Component({
  selector: 'app-offcanvas',
  templateUrl: './offcanvas.component.html',
  styleUrls: ['./offcanvas.component.css']
})
export class OffcanvasComponent implements OnInit {
  
  public currentUser: User;
  public date : Date;

  
  constructor(
    private auth: AuthenticationService,
    private translate: TranslateService,
    public  router : Router,
    public listss : ListsService
    ) {}

  ngOnInit() {
    this.auth.currentUser.subscribe(user => {
      this.currentUser = user;      
    });
    this.date = new Date();
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
      $('[data-toggle="tooltip"]').tooltip('dispose');
    }, environment.READY_TIMEOUT);
  }

  getLanguage() : string{
    return this.translate.currentLang;
  }

  logout() {
    return this.auth.logout().subscribe();
 }


}
